<template>
	<v-card outlined>
		<v-card-title class="pb-2">
			Siti concorrenti
			<v-chip x-small class="ml-2">{{ sites.length }} / {{ max }}</v-chip>
			<v-spacer></v-spacer>
			<v-btn small color="primary" depressed :disabled="pieno" :title="pieno ? `Puoi inserire al massimo ${max} siti` : ''" @click="$emit('add')">
				<v-icon left small>mdi-plus</v-icon>
				Aggiungi sito
			</v-btn>
		</v-card-title>

		<v-list dense class="py-0">
			<v-list-item-group :value="selectedId" color="primary">
				<template v-for="(s, i) in sites">
					<v-divider v-if="i > 0" :key="`d-${s._id}`"></v-divider>
					<v-list-item :key="s._id" :value="s._id" class="py-1" @click="$emit('select', s._id)">
						<v-list-item-content>
							<v-list-item-title class="d-flex align-center">
								<span class="text-truncate">{{ s.name }}</span>
								<v-chip x-small :color="stato(s).colore" outlined class="ml-2">{{ stato(s).testo }}</v-chip>
								<v-chip
									x-small
									:color="s.activeRules ? 'primary' : 'grey'"
									outlined
									class="ml-1"
									:title="s.activeRules ? 'La scansione usa le regole attive del sito' : 'Nessuna regola attiva: la scansione usa le regole standard'"
									@click.stop="$emit('rules', s)"
								>
									{{ s.activeRules ? `Regole v${s.activeRules.version}` : 'Regole standard' }}
								</v-chip>
							</v-list-item-title>
							<v-list-item-subtitle>
								<a :href="s.url" target="_blank" rel="noopener noreferrer" @click.stop>{{ s.url }}</a>
							</v-list-item-subtitle>
							<div class="caption mt-1">
								{{ s.products || 0 }} prodotti · {{ s.matched || 0 }} abbinati
								<span v-if="s.lastScanAt"> · scansione {{ s.lastScanAt | moment('DD/MM/YYYY HH:mm') }}</span>
								<span v-else class="grey--text"> · mai scansionato</span>
							</div>
							<div v-if="motivoBlocco(s)" class="caption error--text">{{ motivoBlocco(s) }}</div>
							<div v-if="s.draftRules && !s.activeRules" class="caption info--text">Ci sono regole in bozza (v{{ s.draftRules.version }}): controllale in "Regole" e attivale.</div>
							<div v-if="s.brokenRules" class="caption warning--text">Il sito è cambiato rispetto alle regole: controlla le versioni delle regole.</div>

							<div v-if="job(s)" class="caption mt-1">
								<v-chip x-small :color="statoJob(job(s)).colore" text-color="white" class="mr-1">{{ tipoJob(job(s)) }}: {{ statoJob(job(s)).testo.toLowerCase() }}</v-chip>
								<span class="grey--text">{{ contatori(job(s)) }}</span>
								<v-progress-linear v-if="attivo(job(s))" indeterminate height="2" color="primary" class="mt-1"></v-progress-linear>
								<div v-if="testoMessaggio(job(s)) && !attivo(job(s))" :class="job(s).status === 'done' ? 'grey--text' : 'warning--text'">{{ testoMessaggio(job(s)) }}</div>
							</div>

							<div class="mt-1">
								<template v-if="attivo(job(s))">
									<v-btn x-small text color="error" @click.stop="$emit('cancel', job(s)._id)"><v-icon left x-small>mdi-stop</v-icon>Interrompi</v-btn>
								</template>
								<template v-else>
									<v-btn x-small text color="primary" @click.stop="$emit('scan', s._id)"><v-icon left x-small>mdi-magnify-scan</v-icon>Scansiona</v-btn>
									<v-btn x-small text color="primary" :disabled="!s.products" @click.stop="$emit('match', s._id)"><v-icon left x-small>mdi-link-variant</v-icon>Riabbina</v-btn>
									<v-btn x-small text color="primary" :disabled="openaiActive === false" :title="openaiActive === false ? erroreOpenai : ''" @click.stop="$emit('generate', s._id)">
										<v-icon left x-small>mdi-robot-outline</v-icon>{{ s.activeRules ? 'Rigenera regole' : 'Genera regole con AI' }}
									</v-btn>
								</template>
								<v-btn x-small text color="primary" @click.stop="$emit('rules', s)"><v-icon left x-small>mdi-file-cog-outline</v-icon>Regole</v-btn>
								<v-btn x-small text @click.stop="$emit('edit', s)"><v-icon left x-small>mdi-pencil</v-icon>Modifica</v-btn>
								<v-btn x-small text color="error" :disabled="attivo(job(s))" @click.stop="daEliminare = s"><v-icon left x-small>mdi-delete</v-icon>Elimina</v-btn>
							</div>
						</v-list-item-content>
					</v-list-item>
				</template>
			</v-list-item-group>
			<v-list-item v-if="sites.length === 0">
				<v-list-item-content class="grey--text">Nessun sito: aggiungi il primo concorrente.</v-list-item-content>
			</v-list-item>
		</v-list>

		<v-dialog :value="!!daEliminare" max-width="460" @input="v => !v && (daEliminare = null)">
			<v-card v-if="daEliminare">
				<v-card-title class="text-h6">Eliminare il sito?</v-card-title>
				<v-card-text>
					Il sito <strong>{{ daEliminare.name }}</strong> verrà eliminato insieme a tutti i suoi prodotti e abbinamenti ({{ daEliminare.products || 0 }} prodotti). L'operazione non si può annullare.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="daEliminare = null">Annulla</v-btn>
					<v-btn color="error" depressed @click="conferma">Elimina</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import { attivo, testoMessaggio, STATI_JOB, STATI_SITO, TIPI_JOB, CONTATORI, ERRORI } from './testi';

export default {
	name: 'CompetitorSiteList',
	props: {
		sites: { type: Array, default: () => [] },
		max: { type: Number, default: 6 },
		selectedId: { type: String, default: null },
		// job piu' recente seguito per sito: { [siteId]: job }
		jobs: { type: Object, default: () => ({}) },
		// null = non noto (il backend risponde comunque openai_not_configured)
		openaiActive: { type: Boolean, default: null },
	},
	data() {
		return { daEliminare: null, erroreOpenai: ERRORI.openai_not_configured };
	},
	computed: {
		pieno() {
			return this.sites.length >= this.max;
		},
	},
	methods: {
		attivo,
		testoMessaggio,
		job(s) {
			return this.jobs[s._id] || s.lastJob || null;
		},
		stato(s) {
			if (attivo(this.job(s))) return { testo: 'In corso', colore: 'primary' };
			if (!s.lastScanAt && !s.status) return { testo: 'Da scansionare', colore: 'grey' };
			return STATI_SITO[s.status] || STATI_SITO.ok;
		},
		motivoBlocco(s) {
			if (s.status === 'blocked') return ERRORI[s.blockedReason] || s.blockedReason || ERRORI.blocked;
			if (s.status === 'requires_browser') return ERRORI.requires_browser;
			return '';
		},
		statoJob(j) {
			return STATI_JOB[j.status] || { testo: j.status || '', colore: 'grey' };
		},
		tipoJob(j) {
			return TIPI_JOB[j.type] || j.type || 'Operazione';
		},
		contatori(j) {
			const c = j.counters || {};
			return Object.keys(c)
				.filter(k => typeof c[k] === 'number')
				.map(k => `${c[k]} ${CONTATORI[k] || k}`)
				.join(' · ');
		},
		conferma() {
			const s = this.daEliminare;
			this.daEliminare = null;
			if (s) this.$emit('delete', s._id);
		},
	},
};
</script>
